var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8721 16.6187L22.6231 15.8019C21.8076 16.3774 20.6896 16.4329 19.8037 15.8529C19.8037 15.8529 16.0005 13.3684 15.6496 13.1355C15.2308 12.8555 14.7089 12.8381 14.2625 13.1284C13.8173 13.4181 10.0928 15.8529 10.0928 15.8529C9.20633 16.4329 8.0902 16.3774 7.27278 15.8019L6.02569 16.6187C4.97923 17.3032 4.68504 18.7052 5.36891 19.751C6.05278 20.7981 7.45536 21.0923 8.50181 20.4071L14.3089 16.6116C14.7663 16.3297 15.1386 16.3297 15.5902 16.6103L21.3947 20.4071C22.4418 21.0923 23.8438 20.7981 24.5283 19.751C25.2108 18.7052 24.9179 17.3032 23.8721 16.6187Z",
    fill: "#7CB142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5256 9.58905C14.6533 9.51034 14.8043 9.46582 14.9656 9.46582C15.1236 9.46582 15.2714 9.50905 15.3991 9.58518C15.6372 9.72776 18.1662 11.4032 18.1662 11.4032C19.0049 11.951 20.083 11.84 20.7952 11.2L22.2307 12.1407C23.1204 12.7207 23.3701 13.9136 22.7888 14.8032C22.2069 15.6923 21.0152 15.9426 20.1256 15.3607C20.1256 15.3607 16.0017 12.6716 15.6011 12.4419C15.2004 12.211 14.7269 12.2013 14.3152 12.4465C13.9811 12.6445 9.77137 15.3607 9.77137 15.3607C8.89008 15.8929 7.68944 15.6923 7.10815 14.8032C6.52686 13.9136 6.77653 12.7207 7.66557 12.1407L9.10234 11.2C9.81395 11.84 10.8914 11.951 11.7314 11.4032C11.7314 11.4032 14.2759 9.74066 14.5256 9.58905Z",
    fill: "#528A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4465 8.90694L18.4884 10.9095C19.2168 11.385 20.1929 11.1798 20.6691 10.4521C21.1446 9.725 20.94 8.74823 20.2123 8.27145L15.4246 5.1392C15.1207 4.95403 14.7768 4.95403 14.4813 5.13661L9.6852 8.27145C8.95617 8.74823 8.75166 9.725 9.22714 10.4521C9.70456 11.1798 10.6794 11.385 11.4078 10.9095L14.4936 8.90565C14.6381 8.81016 14.7891 8.74307 14.9691 8.74307C15.1491 8.74307 15.3033 8.81016 15.4465 8.90694Z",
    fill: "#004711"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2148 22.9409L15.7264 18.8706C15.529 18.5345 15.2413 18.3635 14.9484 18.3545C14.6555 18.3635 14.3671 18.5345 14.1697 18.8706L11.6813 22.9409C11.3587 23.4403 11.4348 24.2371 12.3252 24.2371H17.571C18.4606 24.2371 18.5374 23.4403 18.2148 22.9409Z",
    fill: "#004711"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/신영증권-30.33354b000fdf19727891e3fca5ff417e.svg";
export { ForwardRef as ReactComponent };